import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TradeFailedAction, TradeLoadingAction, TradePendingAction, TradeSuccessAction, TradeUpdateArchivedAction } from './actions';
import { initialTradeState, TradeState } from './state';

const legEventSlice = createSlice({
  name: 'trade',
  initialState: initialTradeState,
  reducers: {
    reset: () => initialTradeState,
    loading: (state: TradeState, action: PayloadAction<TradeLoadingAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: action.payload.loading,
        loaded: !action.payload.loading,
        pending: false,
        trades: state[action.payload.strategyId]?.trades ?? []
      };
    },
    pending: (state: TradeState, action: PayloadAction<TradePendingAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: false,
        loaded: false,
        pending: action.payload.pending,
        trades: state[action.payload.strategyId]?.trades ?? []
      };
    },
    success: (state: TradeState, action: PayloadAction<TradeSuccessAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: false,
        loaded: true,
        pending: false,
        trades: action.payload.trades
      };
    },
    fail: (state: TradeState, action: PayloadAction<TradeFailedAction>) => {
      state[action.payload.strategyId] = {
        error: action.payload.error,
        loading: false,
        loaded: true,
        pending: false,
        trades: state[action.payload.strategyId]?.trades ?? []
      };
    },
    update: (state: TradeState, action: PayloadAction<TradeUpdateArchivedAction>) => {
      const current = state[action.payload.strategyId];
      const item = current.trades.find((x) => x.id === action.payload.trade.id);
      const index = item ? current.trades.indexOf(item) : -1;
      current.trades[index] = { ...action.payload.trade };
      current.loaded = true;
      current.loading = false;
      current.pending = false;
      current.error = undefined;
    }
  }
});

const { actions, reducer } = legEventSlice;
export const { reset, loading, success, fail, pending, update } = actions;
export default reducer;
